// extracted by mini-css-extract-plugin
module.exports = {"tags":"_17369b9","tag":"_531c462","lightGrey":"_6a84b96","purple":"_488dce3","blue":"_57b2938","green":"_102819e","grey":"_e012cb9","yellow":"_bce6cb7","red":"_bc572f1"};